/* ShimChingMD — PDP Protocol v3 (Sept 30). Scroll motion for the story section.
   Reveals (.rv / .rvs / .rv-fade / .gstage), count-ups ([data-count]), parallax (.px), the 21-Day booklet tilt.
   Everything is gated on html.js (set inline at the top of the section) and honours prefers-reduced-motion.
   Nothing here is load-bearing: without JS the content is simply visible. */
(function () {
  'use strict';
  window.__scmdMotion = true;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  // stagger indices
  $$('.rvs').forEach(function (g) { Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); }); });
  $$('.gseg i').forEach(function (el, i) { el.style.setProperty('--i', i); });
  $$('.tbl-wrap tbody tr').forEach(function (tr, i) { tr.style.setProperty('--i', i); });
  $$('.cal .wk .dots2, .gcols .gdays').forEach(function (row) { $$('i', row).forEach(function (d, j) { d.style.setProperty('--j', j); }); });

  function countUp(el) {
    if (el.getAttribute('data-counted')) return;
    el.setAttribute('data-counted', '1');
    var n = parseFloat(el.getAttribute('data-count')), pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    if (reduce || !isFinite(n) || !window.requestAnimationFrame) { el.textContent = pre + n + suf; return; }
    var t0 = performance.now(), dur = 1000 + Math.min(700, n * 3);
    (function tick(now) {
      var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 4);
      el.textContent = pre + Math.round(n * e) + suf;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }

  var els = $$('.rv,.rvs,.rv-fade,.gstage');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in'); io.unobserve(e.target);
        $$('[data-count]', e.target).forEach(countUp);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
    $$('[data-count]').forEach(countUp);
  }

  // parallax on the three photos
  var px = $$('.px').map(function (el) { return { el: el, img: el.querySelector('img'), k: parseFloat(el.getAttribute('data-px')) || 0.12 }; }).filter(function (o) { return o.img; });
  var ticking = false;
  function parallax() {
    ticking = false; var vh = window.innerHeight;
    px.forEach(function (o) {
      var r = o.el.getBoundingClientRect(); if (r.bottom < -40 || r.top > vh + 40) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      o.img.style.transform = 'translate3d(0,' + (p * o.k * 100).toFixed(2) + '%,0) scale(1.12)';
    });
  }
  if (!reduce && fine && px.length) {
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(parallax); } }, { passive: true });
    window.addEventListener('resize', parallax); parallax();
  }

  // the booklet follows the pointer (desktop only)
  var stage = document.getElementById('gstage'), tilt = document.getElementById('gtilt');
  if (stage && tilt && !reduce && fine) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width * 2 - 1, y = (e.clientY - r.top) / r.height * 2 - 1;
      tilt.style.setProperty('--ry', (-16 + x * 11).toFixed(2) + 'deg');
      tilt.style.setProperty('--rx', (5 - y * 8).toFixed(2) + 'deg');
    });
    stage.addEventListener('pointerleave', function () { tilt.style.removeProperty('--ry'); tilt.style.removeProperty('--rx'); });
  }
})();
